export default __webpack_public_path__ + "static/media/tableBooking.7cdd93c5.jpg";